'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './webaccess-show.routes';

export class WebaccessShowComponent {
  constructor($stateParams, WebAccessService, $uibModal, $window, SettingsService, $state, ContactService) {
    'ngInject';

    this.back = _ => $window.history.back();

    this.webaccessId = $stateParams.id;
    this.$uibModal = $uibModal;
    this.$state = $state;

    this.WebAccessService = WebAccessService;
    this.ContactService = ContactService;

    this.refreshData();
  }

  sendInvitation() {
    this.WebAccessService.sendInvitations({ids: [this.wa._id]}, _ => {
      this.refreshData();
    }, err => console.log(err));
  }

  block() {
    this.WebAccessService.update({id: this.webaccessId},{
      isBlocked: true
    }, _ => {
      this.refreshData();
    }, err => {
      console.log("Could not set to blocked");
    });
  }

  unblock() {
    this.WebAccessService.update({id: this.webaccessId},{
      isBlocked: false
    }, _ => {
      this.refreshData();
    }, err => {
      console.log("Could not set to unblocked");
    });
  }

  resetPassword() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'webaccessResetPassword',
      resolve: {
        config: function() {
          return {}
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (password) {

        that.WebAccessService.resetPassword({id: that.webaccessId}, {password}, _=> {
          console.log('success');
        }, err => console.log(err));

      },
      function () { /* cancel */ }
    );

  }

  /**
   *
   *
   *
   *
   */

  computedRoles(wa) {
    if (!wa)
      return [];
    
    let _roles = [];

    if (wa.additionalRoles)
      _roles = _roles.concat(wa.additionalRoles);

    return [...new Set(_roles)];
  }

  refreshData() {
    if (this.webaccessId) {
      this.WebAccessService.get({id: this.webaccessId}, data => {
        this.wa = data;

        if (this.wa.contact) {
          this.ContactService.get({id: this.wa.contact}, contact => {
            this.wa.contact = contact;
          })
        }

      }, err => {
        console.log('Could not load violation ticket from server');
      });
    }
  }

  getComposedName(contact) {
    let composedName = "";

    if (contact.lastName && contact.firstName) {
      composedName = contact.lastName + ", " + contact.firstName;
      if (contact.middleName)
        composedName += " " + contact.middleName;
    }

    if (contact.company) {
      if (composedName == "")
        composedName += contact.company;
      else
        composedName += "<br/>" + contact.company;
    }

    return composedName || "-";
  }

}

export default angular.module('conduu.webaccessShow', [uiRouter])
  .config(routes)
  .component('webaccessShow', {
    template: require('./webaccess-show.html'),
    controller: WebaccessShowComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/webaccess/show/webaccess-show.component.js